module.exports = __webpack_public_path__ + "img/stock5.089dee2a.png";